export const AddressResidenceBodyFormat = (formData, withSedGroups, parentEgnExist, method2FA) => {
    let body = {
        childEgn: formData.childEgn,
        childIsEgn: formData.childIsEgn,
        childName: formData.childName?.trim(),
        childLnchDate: formData.childLnchDate ? FormatDateyyyyMMdd(formData.childLnchDate) : null,
        commonAdvantages: formData.commonAdvantages,
        parentEgn: formData.parentEgn,
        parentEmail: formData.parentEmail?.trim(),
        parentIsEgn: formData.parentIsEgn,
        parentName: formData.parentName?.trim(),
        parentPhone: formData.parentPhone,
        method2FA: method2FA,
        password: formData.password,
        parentExistEgn: parentEgnExist,
        currentAddressResidence: {
            ADDRESS_ID: formData.currentAddress.addresS_ID,
            ADDRESS_RESIDENCE_ID: formData.currentAddress.addresS_RESIDENCE_ID,
            ADDRESS_TEXT: formData.currentAddress.addresS_TEXT,
            CHILD_NAME: formData.currentAddress.chilD_NAME,
            CODE_NM: formData.currentAddress.codE_NM,
            CODE_STREET: formData.currentAddress.codE_STREET,
            CURRENT_ADDR: formData.currentAddress.currenT_ADDR,
            EGN: formData.currentAddress.egn,
            RESIDENCE: formData.currentAddress.residence == null ? addOneDay(formData.childCurrAddressDate) : formData.currentAddress.residence,
            VH: formData.currentAddress.vh,
        },
        permanentAddressResidence: formData.permanentAddress ? {
            address_id: formData.permanentAddress.addresS_ID,
            address_residence_id: formData.permanentAddress.addresS_RESIDENCE_ID,
            address_text: formData.permanentAddress.addresS_TEXT,
            child_name: formData.permanentAddress.chilD_NAME,
            code_nm: formData.permanentAddress.codE_NM,
            code_street: formData.permanentAddress.codE_STREET,
            current_addr: formData.permanentAddress.currenT_ADDR,
            egn: formData.permanentAddress.egn,
            residence: formData.permanentAddress.residence == null ? addOneDay(formData.childPermAddressDate) : formData.permanentAddress.residence,
            vh: formData.permanentAddress.vh,
        } : null,
        twins: formData.twins.map(x => {
            let newObj = { ...x }
            if (x.twinLncDate) {
                newObj.twinLncDate = FormatDateyyyyMMdd(x.twinLncDate);
            }

            return newObj;
        }),
        wishes: formData.wishes.map(x => {
            let obj = {};

            const stringifiedX = Object.fromEntries(
                Object.entries(x).map(([key, value]) => [key, key.includes('_LnchDate') ? FormatDateyyyyMMdd(value) : value.toString()])
            );

            obj.wishData = { ...stringifiedX, school: null };
            obj.school = x.school;

            if (withSedGroups == 0) {
                obj.sedGroup = x.sedGroup;
            }

            return obj;
        }),
    }

    //console.log(body);
    
    return body;
}

export const ManualAddressRegisterBodyFormat = (formData, withSedGroups, parentEgnExist) => {
    let body = {
        childEgn: formData.childEgn,
        childIsEgn: formData.childIsEgn,
        childName: formData.childName?.trim(),
        childLnchDate: formData.childLnchDate ? FormatDateyyyyMMdd(formData.childLnchDate) : null,
        commonAdvantages: formData.commonAdvantages,
        parentExistEgn: parentEgnExist,
        parentEgn: formData.parentEgn,
        parentEmail: formData.parentEmail?.trim(),
        parentIsEgn: formData.parentIsEgn,
        parentName: formData.parentName?.trim(),
        parentPhone: formData.parentPhone,
        currentChildCity: formData.currentChildCity,
        currentAddress: formData.currentAddress,
        password: formData.password,
        currentAddressInfo: formData.currentAddressInfo,
        currentAddressDate: FormatDateyyyyMMdd(formData.currentAddressDate),
        permanentChildCity: formData.permanentChildCity,
        permanentAddress: formData.permanentAddress,
        permanentAddressInfo: formData.permanentAddressInfo,
        permanentAddressDate: FormatDateyyyyMMdd(formData.permanentAddressDate),
        twins: formData.twins.map(x => {
            let newObj = { ...x }
            if (x.twinLncDate) {
                newObj.twinLncDate = FormatDateyyyyMMdd(x.twinLncDate);
            }

            return newObj;
        }),
        wishes: formData.wishes.map(x => {
            let obj = {};

            const stringifiedX = Object.fromEntries(
                Object.entries(x).map(([key, value]) => [key, key.includes('_LnchDate') ? FormatDateyyyyMMdd(value) : value.toString()])
            );

            obj.wishData = { ...stringifiedX, school: null };
            obj.school = x.school;

            if (withSedGroups == 0) {
                obj.sedGroup = x.sedGroup;
            }

            return obj;
        }),
    }

    //console.log(body);

    return body;
}

export const MunicipalityRegisterBodyFormat = (formData) => {
    let body = {
        childEgn: formData.childEgn,
        childIsEgn: formData.childIsEgn,
        childName: formData.childName?.trim(),
        childLnchDate: formData.childLnchDate ? FormatDateyyyyMMdd(formData.childLnchDate) : null,
        commonAdvantages: formData.commonAdvantages,
        parentEgn: formData.parentEgn,
        parentEmail: formData.parentEmail?.trim(),
        parentIsEgn: formData.parentIsEgn,
        parentName: formData.parentName?.trim(),
        parentPhone: formData.parentPhone,
        currentAddress: formData.currentAddress,
        password: formData.password,
        currentAddressDate: formData.dontHaveCurrentAddress ? null : FormatDateyyyyMMdd(formData.currentAddressDate),
        permanentAddress: formData.permanentAddress,
        permanentAddressDate: formData.dontHavePermanentAddress ? null : FormatDateyyyyMMdd(formData.permanentAddressDate),
        twins: formData.twins.map(x => {
            let newObj = { ...x }
            if (x.twinLncDate) {
                newObj.twinLncDate = FormatDateyyyyMMdd(x.twinLncDate);
            }

            return newObj;
        }),
        wishes: formData.wishes.map(x => {
            const stringifiedX = Object.fromEntries(
                Object.entries(x).map(([key, value]) => [key, key.includes('_LnchDate') ? FormatDateyyyyMMdd(value) : value.toString()])
            );

            return {
                wishData: { ...stringifiedX, school: null },
                school: x.school,
                sedGroup: x.sedGroup
            }
        }),
    }

    //console.log(body);

    return body;
}

export const FormatDate = (date) => {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return`${day}.${month}.${year}`;
}


export const FormatDateBG = (date) => {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    
    return `${day}-${month}-${year}`;
}

export const FormatDateyyyyMMdd = (date) => {
    if (date) {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');

        return `${year}${month}${day}`;
    }

    return null;
}

export const StringToDate = (dateString) => {
    if (!dateString) {
        return null
    }
    const [day, month, year] = dateString.split('.').map(Number);

    return new Date(year, month - 1, day);
}

export const StringToDateWithDash = (dateString) => {
    if (!dateString) {
        return null
    }
    const [day, month, year] = dateString.split('-').map(Number);

    return new Date(year, month - 1, day);
}

export const StringyyyyMMddToDate = (dateString) => {
    if (dateString == null) {
        return null
    }

    const year = dateString.slice(0, 4);
    const month = dateString.slice(4, 6);
    const day = dateString.slice(6, 8);

    return new Date(year, month - 1, day);
}

export const formatDateForTokens = (date) => {
    const options = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false // To use 24-hour format
    };

    const formattedDate = new Intl.DateTimeFormat('bg-BG', options).format(date);
    return formattedDate.replace(',', ''); // Remove any commas
}

const addOneDay = (date) => {
    if (!date) return null;
    const d = new Date(date);
    d.setDate(d.getDate() + 1);
    return d;
};